"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSwapPrintableLayerUserData = void 0;
const UserPhotoLayer_1 = require("../models/layers/UserPhotoLayer");
const typeguard_1 = require("../types/typeguard");
const PrintableAction_1 = require("./PrintableAction");
const isSwapPrintableLayerUserDataRuleSet = {
  type: value => value === 'SWAP_PRINTABLE_LAYER_USER_DATA',
  targetLayerId: typeguard_1.isNonEmptyString,
  targetUserData: value => (0, UserPhotoLayer_1.isUserPhotoLayerUserData)(value) || value === null,
  sourceLayerId: typeguard_1.isNonEmptyString,
  sourcePrintableId: typeguard_1.isNonEmptyString,
  sourceUserData: value => (0, UserPhotoLayer_1.isUserPhotoLayerUserData)(value) || value === null
};
const isSwapPrintableLayerUserData = p => (0, PrintableAction_1.isPrintableAction)(p) && (0, typeguard_1.isType)(p, isSwapPrintableLayerUserDataRuleSet);
exports.isSwapPrintableLayerUserData = isSwapPrintableLayerUserData;